// latest: zhangmyh 2017-10-16 2:31 PM
import { Model } from 'common'
import './sectionEnumList'
import './sectionValueList'

Model.define('certification.model', {
  proxy: {
    post: '/cpu-supplymgr/certificationIndicator/saveCertificationIndicator',
    get: '/cpu-supplymgr/certificationIndicator/getById'
  },
  meta: {
    id: '',
    code: '',
    name: {
      type: 'string',
      required: true,
      nullMsg: '请填写名称'
    },
    classId: '',
    className: '',
    description: '',
    indicatorType: '',
    scoreBasis: '',
    orgId: '',
    orgName: '',
    type: 0,
    unit: '',
  },
  associations: {
    sectionEnumList: {
      type: 'hasMany', // hasMany
      model: 'certification.sectionEnumList'
    },
    sectionValueList: {
      type: 'hasMany', // hasMany
      model: 'certification.sectionValueList'
    },
  }
})

export default Model.create('certification.model')



// WEBPACK FOOTER //
// ./src/data/model/certification/index.js